import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

export interface ETOCheckBoxProps {
  autoFocus?: boolean;
  name: string;
  // eslint-disable-next-line no-unused-vars
  label?: string;
  // eslint-disable-next-line no-unused-vars
  disabled?: boolean;
  value?: boolean;
  size?: 'small' | 'medium';
  handleChange?: React.ChangeEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLButtonElement>;
  onFocus?: React.FocusEventHandler<HTMLButtonElement>;
  onBlur?: React.FocusEventHandler<HTMLButtonElement>;
}

const ETOCheckBox: React.FC<React.PropsWithChildren<ETOCheckBoxProps>> = (props) => {
  const {
    name, label, disabled, handleChange, value, autoFocus, size, onFocus, onKeyDown, onBlur,
  } = props;

  return (
    <FormControlLabel
      control={(
        <Checkbox
          size={size}
          autoFocus={autoFocus}
          checked={value}
          onChange={(e) => {
            if (handleChange) handleChange(e);
          }}
          disabled={disabled}
          name={name}
          color="primary"
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          onBlur={onBlur}

        />
    )}
      label={label}
    />
  );
};

export default ETOCheckBox;
